import { FormlyFormOptions } from '@ngx-formly/core';

export type SnFormOptions = FormlyFormOptions;
